const zh =  {
    pageTitle: '全新推薦獎賞計劃 | 香港寬頻',
    loginLabel1: '請輸入電話號碼及香港寬頻賬戶或 ',
    loginLabel2: ' 查詢您的推薦人編號',
    contactLabel: ' 請輸入電話號碼或 ',
    loginLinkLabel: '登入myHKBN',
    loginText: '登入',
    accountLabel: '香港寬頻賬戶',
    contactNoLabel: '電話號碼',
    ReferralCode: '您的推薦人編號',
    ReferralCodeError: '請輸入有效的推薦人編號',
    TNC: '條款及細則',
    share: '分享',
    copySuccess: '成功',
    QNATitle: '常見問題',
    HowToTitle: '如何推薦',
    StaticBarTextLeft: '【全新推薦獎賞】以推薦人編號「',
    StaticBarTextRight: '」登記指定計劃，共享高達$1900賬額回贈！',
    StaticBarTNC: '優惠受條款及細則約束',
};
 
export default zh;